"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveCard = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var myPage_1 = require("../../model/myPage");
var service_1 = require("../../../library/base/service");
var ActiveCard = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ActiveCard, _super);
    function ActiveCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '激活临时会员卡';
        _this.code = '101113';
        _this.desc = '激活临时会员卡';
        _this.requestParams = new myPage_1.ActiveCardRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ActiveCard;
}(service_1.BaseService));
exports.ActiveCard = ActiveCard;
//# sourceMappingURL=activeCard.js.map